module.exports = "td:first-child:first-letter {\r\n    text-transform: capitalize;\r\n}\r\n"